module.exports = __webpack_public_path__ + "img/proberaum.827855ca.jpeg";